/*
 * Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
 * This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
 * The receipt or possession of this program does not convey any rights to use, reproduce or disclose
 * its contents in whole or in part, without the specific written consent of Inovalon, Inc.
 * Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
 * is a violation of the copyright laws and may subject you to criminal prosecution.
 */
import React from 'react'
import { RouteComponentProps, Route } from 'react-router-dom'
import { observer } from 'mobx-react'
import { Spinner } from 'reactstrap'
import 'react-datepicker/dist/react-datepicker.css'
import './CoverageDiscoveryResponse.scss'
import { BaseResponseComponent } from '../BaseResponse/BaseResponse'
import { TopPart } from '../../TopPart/TopPart'
import { ICoverageDiscoveryResponseStateManager, IBaseResponseDetail } from '../../../services/CoverageDiscoveryResponseStateManager/contracts'
import { IUserSessionStateManager } from '../../../arc/services/UserSessionStateManager/contracts'
import { container } from '../../../arc/configuration/ServiceLocator'
import { ICoverageDiscoveryTransaction, ICoverageDiscoveryTransactionStateManager } from '../../../services/CoverageDiscoveryTransactionStateManager/contracts'

export interface IResponseProps extends RouteComponentProps<any> {
	cdTransactionId: number
	usersessionStateManager: IUserSessionStateManager
	CoverageDiscoveryResponseStateManager: ICoverageDiscoveryResponseStateManager
	CoverageDiscoveryTransactionStateManager: ICoverageDiscoveryTransactionStateManager
}

interface IResponseState {
	cdTransaction?: ICoverageDiscoveryTransaction
	baseResponseDetail: IBaseResponseDetail[]
	IsPageLoading: boolean
	showErrorMessage: boolean
	errorMessage: string
}

@observer
export class CoverageDiscoveryResponse extends React.Component<IResponseProps, IResponseState> {
	constructor(props: Readonly<IResponseProps>) {
		super(props)

		this.state = {
			IsPageLoading: true,
			baseResponseDetail: [],
			showErrorMessage: false,
			errorMessage: '',
		}
	}

	componentDidMount(): void {
		this.props.CoverageDiscoveryTransactionStateManager.get(this.props.cdTransactionId)
			.then(item => {
				if (item.responseId) {
					this.props.CoverageDiscoveryResponseStateManager.getBaseResponseDetails(item.responseId).then(subItem => {
						this.setState(() => ({
							cdTransaction: item,
							baseResponseDetail: subItem,
							IsPageLoading: false,
						}))
					})
				} else
					this.setState(() => ({
						cdTransaction: item,
						IsPageLoading: false,
					}))
			})
			.catch(error => {
				this.setState({
					showErrorMessage: true,
					errorMessage: error.toString(),
					IsPageLoading: false,
				})
			})
		window.scrollTo(0, 0)
	}
	setIsPageLoadState(val: boolean): void {
		this.setState({
			IsPageLoading: val,
		})
	}

	render(): React.ReactNode {
		if (this.state.showErrorMessage) {
			return (
				<div>
					<TopPart pagesource="response" />
					<div className="response-content row  tab-content">
						<div className="width100P">
							<div className="contentBody  cd-response">
								<div className="row-fluid">
									<div className="p-3 my-2 rounded">
										<div className="response-error">{this.state.errorMessage}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		}

		if (this.state.IsPageLoading) {
			return (
				<div>
					<TopPart pagesource="response" />
					<div className="row  tab-content">
						<div className="spinnerPage">
							<Spinner animation="border" role="status" />
						</div>
					</div>
				</div>
			)
		} else {
			return (
				<div>
					<TopPart pagesource="response" />
					<BaseResponseComponent cdTransaction={this.state.cdTransaction} baseResponseDetail={this.state.baseResponseDetail} CoverageDiscoveryResponseStateManager={this.props.CoverageDiscoveryResponseStateManager} />
				</div>
			)
		}
	}
}
export const CoverageDiscoveryResponseConnected = (): any => {
	const CoverageDiscoveryResponseStateManager = container.get<ICoverageDiscoveryResponseStateManager>('ICoverageDiscoveryResponseStateManager')
	const coverageDiscoveryTransactionStateManager = container.get<ICoverageDiscoveryTransactionStateManager>('ICoverageDiscoveryTransactionStateManager')
	const userSessionStateManager = container.get<IUserSessionStateManager>('IUserSessionStateManager')
	return <Route path="/CoverageDiscoveryResponse/:cdTransactionId?" render={(props): JSX.Element => <CoverageDiscoveryResponse {...props} cdTransactionId={props.match.params.cdTransactionId} CoverageDiscoveryResponseStateManager={CoverageDiscoveryResponseStateManager} CoverageDiscoveryTransactionStateManager={coverageDiscoveryTransactionStateManager} usersessionStateManager={userSessionStateManager} />} />
}
